import { TableColumn as HeroUiTableColumn } from '@heroui/table';

export const TableColumn = HeroUiTableColumn;
